export const SETLOADING = 'SETLOADING';
export const KYCREJECTMODALLOADER = "KYCREJECTMODALLOADER"